import React, { useEffect, useRef, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import { GridColDef } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
    Box,
    Divider,
    Stack,
    Grid,
    Typography,
    Input,
    Button,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Drawer,
    TableBody,
    Modal,
    Autocomplete,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getId } from "../../../utils/Constant";
import ButtonWithLoader from "../../../utils/ButtonWithLoader";
import CustomLabel from "../../../CustomLable";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
// import CustomDataGrids from "../../../utils/CustomDataGrids";
import CustomDataGrid from "../../../utils/CustomDatagrid";
import DataGrids from "../../../utils/Datagrids";
import { format } from 'date-fns';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {
    GoogleMap,
    InfoWindow,
    LoadScript,
    Marker,
} from "@react-google-maps/api";
import PrintIcon from "@mui/icons-material/Print";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";

interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}


const containerStyle = {
    width: "100%",
    height: "450px",
};


const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95%",
    height: "85%",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};

export default function PoleInstallReport() {
    const Userid = getId();
    let navigate = useNavigate();
    const [IsShow, setShow] = useState(false);
    const [zones, setZones] = useState([]);
    const [columns, setColumns] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const [lang, setLang] = useState<Language>("en");
    const [permissionData, setPermissionData] = useState<MenuPermission>({
        isAdd: false,
        isEdit: false,
        isPrint: false,
        isDel: false,
    });


    const [swipModal, setSwipModal] = useState(false);
    const { t } = useTranslation();

    const [swipData, setSwipData] = useState<any>([]);
    const [Option, setOption] = useState([
        { value: "-1", label: t("text.SelectZone") },
    ]);

    const [taxOption, setTaxOption] = useState([
        { value: "-1", label: t("text.SelectWard") },
    ]);

    const [selectedFormat, setSelectedFormat] = useState<any>("pdf");
    const [isPrint, setPrint] = useState([]);
    const [isHovered, setIsHovered] = useState(false);




    useEffect(() => {
        // fetchZonesData();

        getZone();
    }, []);




    const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFormat((event.target as HTMLInputElement).value);
    };

    const downloadTabularExcel = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to Tabular HTML.");
            return;
        }

        // Prepare headers and rows for HTML table
        const headers = [
            "Serial Number",
            "Zone Name",
            "Ward Name",
            "Installation Date",
            // "Voucher Type",
            // "In Quantity",
            // "Out Quantity",
        ];

        const rows = isPrint.map((item: any,index:any) => [
            index + 1,
            item?.zoneName || "",
            item.wardName ? `${item.wardName} (${item.wardNo})` : "_ _" ,
            item?.poleInstdate.slice(0,10) || "",
            // item?.voucherType || "",
            // item?.inQty || "_ _",
            // item?.outQty || "_ _",
        ]);

        // Create HTML table with enhanced styles and icons
        let html = `
          <html>
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Pole Installation Report</title>
              <!-- Include FontAwesome icons for visuals -->
              <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
              <style>
                body {
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                  background-color: #f0f4f7;
                  color: #333;
                  margin: 0;
                  padding: 0;
                }
                .report-container {
                  width: 95%;
                  max-width: 1200px;
                  margin: 40px auto;
                  background-color: #ffffff;
                  border-radius: 10px;
                  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
                  padding: 40px;
                  padding-bottom: 60px;
                }
                .header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 30px;
                }
                .logo {
                  max-width: 150px;
                  height: auto;
                }
                .header-title {
                  text-align: center;
                  color: #1a73e8;
                  font-size: 28px;
                  font-weight: 600;
                  flex-grow: 1;
                }
                .generated-date {
                  color: #888;
                  font-size: 14px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 30px;
                }
                th {
                  background-color: #1a73e8;
                  color: white;
                  font-weight: bold;
                  padding: 16px;
                  text-align: left;
                  border: 1px solid #ddd;
                  text-transform: uppercase;
                }
                td {
                  padding: 12px;
                  text-align: left;
                  border: 1px solid #ddd;
                  font-size: 16px;
                  color: #333;
                }
                tr:nth-child(even) {
                  background-color: #f7f7f7;
                }
                tr:hover {
                  background-color: #f1f1f1;
                }
                .footer {
                  text-align: center;
                  font-size: 14px;
                  color: #888;
                  margin-top: 40px;
                }
                .footer a {
                  color: #1a73e8;
                  text-decoration: none;
                }
                .footer a:hover {
                  text-decoration: underline;
                }
                .page-footer {
                  font-size: 12px;
                  color: #aaa;
                  margin-top: 40px;
                }
              </style>
            </head>
            <body>
              <div class="report-container">
                <!-- Header Section: Logo, Title, Date -->
                <div class="header">
                  <img class="logo" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQb4HkK_VJ8hgOaOz_hcsBXPslnFWgCrfxFg&s" alt="Company Logo">
                  <div class="header-title">Pole Installation Report</div>
                  <div class="generated-date">
                    Generated on: ${new Date().toLocaleDateString("en-GB")}
                  </div>
                </div>
                
                <!-- Table Section -->
                <table>
                  <thead>
                    <tr>
                      ${headers.map((header) => `<th>${header}</th>`).join("")}
                    </tr>
                  </thead>
                  <tbody>
                    ${rows
                .map(
                    (row: any) =>
                        `<tr>${row
                            .map(
                                (cell: any) =>
                                    `<td>${cell}</td>`
                            )
                            .join("")}</tr>`
                )
                .join("")}
                  </tbody>
                </table>
                
                <div class="footer">
                  <p>Company Name | <a href="mailto:support@company.com">Contact Us</a></p>
                </div>
              </div>
            </body>
          </html>
        `;

        // Create a Blob from the HTML string and trigger the download
        const blob = new Blob([html], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Pole_Instalation_Report_tabular.html";
        link.click();
    };



    const downloadExcel = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to Excel.");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(isPrint);

        const headers = Object.keys(isPrint[0]);

        headers.forEach((header, index) => {
            const cellAddress = `${String.fromCharCode(65 + index)}1`;
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "reports");

        XLSX.writeFile(wb, "Pole_Instalation.xlsx");
    };

    // Function to download PDF

    // Handle Download Button Click
    const handleDownload = () => {
        if (selectedFormat === "excel") {
            downloadExcel();
        } else if (selectedFormat === "pdf") {
            downloadPDF();
        } else if (selectedFormat === "tabular") {
            downloadTabularExcel();
        }
    };

    const downloadPDF = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to PDF.");
            return;
        }

        // Initialize jsPDF with 'landscape' orientation
        const doc = new jsPDF("landscape"); // This sets the page orientation to landscape
        let yPosition = 10;
        const headerFontSize = 14;
        const bodyFontSize = 12;

        doc.setFontSize(headerFontSize);
        doc.setFont("helvetica", "bold");
        doc.text("Vehicle Data", 14, yPosition);
        yPosition += 10;

        const headers = ["Serial Number","Zone Name", "Ward Name", "Installation Date"];

        const columnWidths = [50, 50, 70, 50, 50];

        const headerHeight = 8;
        const headerY = yPosition;
        doc.setFillColor(200, 220, 255);
        doc.rect(
            14,
            headerY,
            columnWidths.reduce((a, b) => a + b, 0),
            headerHeight,
            "F"
        );

        doc.setFont("helvetica", "bold");
        headers.forEach((header, index) => {
            doc.text(
                header,
                14 + columnWidths.slice(0, index).reduce((a, b) => a + b, 0),
                yPosition + headerHeight - 2
            );
        });

        const headerBottomMargin = 6;
        yPosition += headerHeight + headerBottomMargin;

        // Add table rows
        doc.setFontSize(bodyFontSize);
        doc.setFont("helvetica", "normal");

        isPrint.forEach((item: any, rowIndex) => {
            const row = [
                rowIndex + 1 ,
                item?.zoneName || "",

                item.wardName ? `${item.wardName} (${item.wardNo})` : "_ _" , // Vehicle No
                item?.poleInstdate.slice(0,10) || "", // Driver
               
            ];

            row.forEach((cell, colIndex) => {
                const xOffset =
                    14 + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
                if (cell) {
                    doc.text(cell.toString(), xOffset, yPosition);
                }
            });
            yPosition += 10;

            if (yPosition > 180) {
                // Adjust this to your content size for landscape
                doc.addPage();
                yPosition = 10; // Reset position on new page
            }
        });

        // Save the generated PDF with a filename
        doc.save("Pole_Instalation_Report.pdf");
    };

    const getZone = async () => {
        const collectData = {
            zoneID: -1,
            user_ID: "",
        };
        const res = await api.post(`Zone/GetZonemaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.zoneName,
                value: item.zoneID,
            })) || [];

        setOption(arr);
    };

    const getWardData = async (Id: any) => {
        const collectData = {
            areaID: -1,
            zoneID: Id
        };
        const res = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.areaName,
                value: item.areaID,
            })) || [];

        setTaxOption(arr);
    };




    const [vehicles, setVehicles] = useState<any>([]);
    const [activeVehicle, setActiveVehicle] = useState<any>(null);
    const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
    const mapRef: any = useRef(null);
    const [currentMap, setCurrentMap] = useState(false);



    // Fetch the vehicle data from API
    const MapData = async (Id: any) => {
        setCurrentMap(true);

        const result = await api.post(`PoleInstallation/GetPoleInstallation`, {
            poleInstId: Id,
            zoneId: -1,
            wardId: -1,
            "show": true,
            "exportOption": ""
        });
        const validItems = result?.data?.data[0]["poleInstalChild"];

        console.log("validItems", validItems);
        const arr = validItems.map((item: any, index: any) => ({
            lat: parseFloat(item?.latitute),
            lng: parseFloat(item?.longitute),
            id: index + 1,
            itemName: item?.itemName,
            empName: item?.empName,

            depth: item.depth,
            tracktime: format(item?.apprdate, 'dd-MM-yyyy'),
            poleno: item.poleno,
            zoneName: item?.zoneName,
            wardName: item.wardName,

            icon: "https://cdn-icons-png.flaticon.com/512/209/209403.png",
        }));
        setVehicles(arr);
        setCenter(calculateCenter(arr));

        if (arr.length > 0) {
            adjustZoomLevel(arr);
        }
    };

    const calculateCenter = (vehicles: any) => {
        if (vehicles.length === 0) {
            return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
        }

        const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
        const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

        const avgLat =
            latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
        const avgLng =
            longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
            longitudes.length;

        return { lat: avgLat, lng: avgLng }; // Return the center point
    };

    // Adjust the zoom level based on the spread of the vehicles
    const adjustZoomLevel = (vehicles: any) => {
        const bounds = new window.google.maps.LatLngBounds();

        vehicles.forEach((vehicle: any) => {
            bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
        });

        if (mapRef.current) {
            mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
        }
    };

    const handleMarkerMouseOver = (vehicle: any) => {
        setActiveVehicle(vehicle);
    };

    const handleMarkerMouseOut = () => {
        setActiveVehicle(null);
    };





    const getSwipDataPole = async (Id: any) => {
        setSwipModal(true);
        try {

            const collectData = {
                "poleInstId": Id, "zoneId": -1, "wardId": -1, "show": true, "exportOption": ""
            };


            const response = await api.post(
                `PoleInstallation/GetPoleInstallation`, collectData
            );
            const data = response.data.data[0]?.poleInstalChild;

            setSwipData(data)

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };




    const formik = useFormik({
        initialValues: {

            "zoneId": -1,
            "wordId": -1,
            fromDate: null,
            toDate: null,
            poleNo: "",
            "wordId1": -1,
            fromDate1: null,
            toDate1: null,
            compStatusId: -1,
            "empId": -1,
            "zoneId2": -1,
            "wordId2": -1,
            "complaintNo": "",
            "fromDate2": null,
            "toDate2": null


        },
        // validationSchema: validationSchema,
        onSubmit: async (values) => {

        },
    });


    const fetchZonesData = async () => {
        setShow(true);
        try {
            const collectData = {
                poleInstId: -1,
                zoneId: formik.values.zoneId,
                wardId: formik.values.wordId,
                "show": true,
                "exportOption": "",
                "fromDate": formik.values.fromDate,
                "toDate": formik.values.toDate
            };
            const response = await api.post(`PoleInstallation/GetPoleInstallation`, collectData);
            const data = response.data.data;


            const Print = data.map((item: any, index: any) => ({
                ...item,
            }));
            setPrint(Print);
            // console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
            const zonesWithIds = data.map((zone: any, index: any) => ({
                ...zone,
                serialNo: index + 1,
                id: zone.poleInstId,
                 wardWithNumber: zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _"
            }));
            setZones(zonesWithIds);
            setIsLoading(false);

            if (data.length > 0) {
                const columns: GridColDef[] = [


                    {
                        field: "serialNo",
                        headerName: t("text.SrNo"),
                        flex: .5,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "zoneName",
                        headerName: t("text.zoneName"),
                        flex: 1,
                        renderCell: (params) => {
                            return (
                                <div
                                    style={{ cursor: 'pointer', color: "blue" }}
                                    onClick={() => getSwipDataPole(params.row.id)}
                                >
                                    {params.value}
                                </div>
                            );
                        },
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "wardWithNumber",
                        headerName: t("text.wardName"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },

                    {
                        field: "poleInstdate",
                        headerName: t("text.InstallationDate"),
                        valueFormatter: (params) => {
                            const date = new Date(params.value);
                            return date ? format(date, 'dd-MM-yyyy') : '__';
                        },
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },

                    {
                        field: "map",
                        headerClassName: "MuiDataGrid-colCell",
                        headerName: t("text.Map"),
                        width: 150,

                        renderCell: (params) => {
                            return [
                                <Stack
                                    spacing={1}
                                    direction="row"
                                    sx={{ alignItems: "center", marginTop: "5px" }}
                                >




                                    <LocationOnIcon
                                        style={{
                                            fontSize: "20px",
                                            color: "#65b7c9",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            MapData(params.row.id);
                                        }}
                                    />
                                </Stack>,
                            ];
                        },
                    },



                ];
                setColumns(columns as any);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const adjustedColumns = columns.map((column: any) => ({
        ...column,
    }));


    return (
        <>
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "lightgreen",
                    border: ".5px solid #2B4593",
                    marginTop: "3vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                    }}
                    style={{ padding: "10px" }}
                >
                    <ConfirmDialog />

                    <Grid item xs={12} container spacing={1}>
                        <Grid item lg={10} md={10} xs={12}>
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{ padding: "20px" }}
                                align="left"
                            >
                                {t("text.PoleInstalledReport")}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Box height={10} />

                    <Stack direction="row" spacing={2} classes="my-2 mb-2">

                        {/* <Button
                onClick={routeChangeAdd}
                variant="contained"
                endIcon={<AddCircleIcon />}
                size="large"
                style={{backgroundColor:`var(--header-background)`}}
              >
                {t("text.add")}
              </Button> */}

                    </Stack>


                    <Grid
                        item
                        xs={12}
                        container
                        spacing={2}
                        sx={{ marginTop: "1%" }}
                    >
                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={Option}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("zoneId", newValue?.value);
                                    // formik.setFieldValue("zoneName", newValue?.label);
                                    getWardData(newValue?.value)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectZone")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />

                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={taxOption}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("wordId", newValue?.value);
                                    //formik.setFieldValue("wardName", newValue?.label);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectWard")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.FromDate")} />}
                                value={formik.values.fromDate}
                                name="fromDate"
                                id="fromDate"
                                placeholder={t("text.FromDate")}
                                size="small"
                                fullWidth
                                type="date"
                                style={{ backgroundColor: "white" }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item sm={4} lg={4} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.ToDate")} />}
                                value={formik.values.toDate}
                                name="toDate"
                                id="toDate"
                                placeholder={t("text.ToDate")}
                                type="date"
                                size="small"
                                fullWidth
                                style={{ backgroundColor: "white" }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>




                        <Grid item xs={12} lg={2}>

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth={true}
                                style={{
                                    // width: "60%",

                                    backgroundColor: `var(--header-background)`,
                                    //margin: "1%",
                                }}
                                onClick={() => {
                                    fetchZonesData();

                                }}
                            >
                                {t("text.show")}
                            </Button>


                        </Grid>


                        <Grid
                            item
                            xs={12}
                            sm={1}
                            lg={1}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={handleDownload}
                        >
                            <PrintIcon
                                style={{ color: isHovered ? "black" : "blue" }}
                                fontSize="large"
                            />
                        </Grid>


                        <Grid item xs={12} sm={4} lg={4}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    value={selectedFormat}
                                    onChange={handleFormatChange}
                                >
                                    <FormControlLabel
                                        value="pdf"
                                        control={<Radio />}
                                        label="PDF"
                                    />
                                    <FormControlLabel
                                        value="excel"
                                        control={<Radio />}
                                        label="Excel"
                                    />
                                    <FormControlLabel
                                        value="tabular"
                                        control={<Radio />}
                                        label="Tabular Excel"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {IsShow && (

                        <Grid xs={12} lg={12} sm={12} item>

                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <CircularProgress />
                                </div>
                            ) : (
                                <DataGrids
                                    isLoading={isLoading}
                                    rows={zones}
                                    columns={adjustedColumns}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    initialPageSize={5}
                                />
                            )}

                        </Grid>
                    )}



                    <Grid xs={12} lg={12} sm={12} item>
                        <Drawer
                            anchor="right"
                            style={{ zIndex: 1400 }}
                            open={swipModal}
                            onClose={() => setSwipModal(false)}
                        >
                            {/* Drawer content */}
                            <div style={{ width: '700px', padding: '20px', backgroundColor: '#f4f7fc' }}>
                                {/* Header with color */}
                                <div
                                    style={{
                                        backgroundColor: '#1976D2', // Blue color for header
                                        color: '#fff',
                                        padding: '15px 20px',
                                        borderRadius: '8px 8px 0 0',
                                        textAlign: 'center',
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Pole Installed Item Details
                                </div>

                                {/* Table container with better padding and spacing */}
                                <TableContainer style={{ marginTop: '20px' }}>
                                    <Table style={{ minWidth: 650 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd', // Light blue for header background
                                                        fontWeight: 'bold',
                                                        color: '#1976D2', // Blue text color
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap', // Prevent text wrapping in header
                                                    }}
                                                >
                                                    Poleno
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Install of Light
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Latitude
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Longitude
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Depth
                                                </TableCell>

                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Image
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Employee Name
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {swipData.map((item: any) => (
                                                <TableRow key={item.poleInstChildId}>
                                                    <TableCell style={{ textAlign: 'left' }}>{item.poleno}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>
                                                        {item.installOfLight}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.latitute}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.longitute}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.depth}</TableCell>

                                                    <TableCell>
                                                        <img
                                                            src={item.poleimg}
                                                            alt={`Pole Image ${item.poleInstChildId}`}
                                                            style={{ width: '50px', height: '50px', borderRadius: '8px' }}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'left' }}>{item.empName}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Drawer>
                    </Grid>



                    <Modal open={currentMap} onClose={() => setCurrentMap(false)}>
                        <Box sx={style}>
                            {currentMap && (
                                <Grid item xs={12} sm={12} lg={12}>
                                    {/* {isLoading1 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress />
                        </div>
                      ) : ( */}
                                    <GoogleMap
                                        mapContainerStyle={containerStyle}
                                        center={center}
                                        zoom={70} // Default zoom, will be adjusted by `fitBounds`
                                        onLoad={(map: any) => (mapRef.current = map)}
                                    >
                                        {vehicles.map((vehicle: any) => (
                                            <Marker
                                                key={vehicle.id}
                                                position={{
                                                    lat: vehicle.lat,
                                                    lng: vehicle.lng,
                                                }}
                                                icon={{
                                                    url: vehicle.icon,
                                                    scaledSize: new window.google.maps.Size(
                                                        50,
                                                        50
                                                    ),
                                                    origin: new window.google.maps.Point(0, 0),
                                                    anchor: new window.google.maps.Point(25, 25),
                                                }}
                                                onMouseOver={() =>
                                                    handleMarkerMouseOver(vehicle)
                                                } // Show vehicle number on hover
                                                onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
                                            >
                                                {activeVehicle &&
                                                    activeVehicle.id === vehicle.id && (
                                                        <InfoWindow>
                                                            <div>
                                                                <div>
                                                                    <strong>Zone Name: </strong>
                                                                    {vehicle.zoneName}
                                                                </div>

                                                                <div>
                                                                    <strong>Ward Name: </strong>
                                                                    {vehicle.wardName}
                                                                </div>

                                                                <div>
                                                                    <strong>Depth: </strong>
                                                                    {vehicle.depth}
                                                                </div>

                                                                <div>
                                                                    <strong>Pole No: </strong>
                                                                    {vehicle.poleno}
                                                                </div>

                                                                <div>
                                                                    <strong>Date : </strong>
                                                                    {vehicle.tracktime}
                                                                </div>
                                                            </div>
                                                        </InfoWindow>
                                                    )}
                                            </Marker>
                                        ))}
                                    </GoogleMap>
                                    {/* )} */}
                                </Grid>
                            )}
                        </Box>
                    </Modal>
                </Paper>
            </Card>
            <ToastApp />
        </>
    );
}
